module.exports = __webpack_public_path__ + "static/media/workout-tracker.5b1848d7.png";